
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class DepartmentFeatureAccessibleMixin extends Mixins() {
  get isDepartmentFeatureEnable(): boolean {
    // 固定の場合は部署機能を使わないと判断.万一固定だけど使うというユースケースがあった場合は設定を見直し.
    return !this.$configuration.behavior.department.fixed.isEnable && this.$configuration.behavior.department.feature.isEnable;
  }
}
